enum ResearchStatus {
    NOT_FILLED,
    SEARCHING,
    DONE
}

export default ResearchStatus;
